module.exports = __webpack_public_path__ + "static/media/microscopy-nsit0108-01 3.32b39b34.png";